<template>
    <div class="bg-white px-3">
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="transaction_id" label="交易流水号" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="order_source_text" label="来源类型" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="nickname" label="用户名" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="total_fee" label="交易金额" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="payment_method" label="支付方式" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="action" label="交易状态" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="create_time" label="交易时间" show-overflow-tooltip> </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        mapState
    } from 'vuex'
    export default {
        props:['times'],
        data() {
            return {
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                date: xaoi.date,
                typess:''
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                that.heights = window.innerHeight  - 320 + 'px'
                window.onresize = () => {
                    that.heights = window.innerHeight  - 320 + 'px'
                }
            },
            begin(t) {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                this.typess=t
                that.search(t)
            },
            search(t) {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/OrderLog/CapitalFlow", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        start_time: this.times ? this.times[0] : '',
                        end_time: this.times ? this.times[1] : '',
                        type:1,
                        order_source:t
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search(this.typess)
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search(this.typess)
            },
        },

    };
</script>


<style>

</style>